import LanguageService from "./LanguageService";

let ValidService = {};
ValidService.required = {
  required: true,
  message: LanguageService.lang.valid_required,
  trigger: ["blur", "change"],
};
ValidService.requiredBlur = {
  required: true,
  message: LanguageService.lang.valid_required,
  trigger: ["blur"],
};
ValidService.requiredChange = {
  required: true,
  message: LanguageService.lang.valid_requiredChange,
  trigger: "change",
};
ValidService.requiredNoMessage = {
  required: true,
  message: " ",
  trigger: "blur",
};
ValidService.checkAz09 = {
  pattern: /^[0-9a-zA-Z]+$/g,
  message: LanguageService.lang.valid_az09,
  trigger: "blur",
};
ValidService.checkAz09Dot = {
  pattern: /^[\d.\.]$/g,
  message: LanguageService.lang.valid_az09Dot,
  trigger: "blur",
};
ValidService.checkAccount = {
  pattern: /^[0-9a-zA-Z.@]+$/g,
  message: LanguageService.lang.valid_account,
  trigger: "blur",
};
ValidService.checkPassFull = {
  pattern: /^[0-9a-zA-Z.@]+$/g,
  message: LanguageService.lang.valid_passwordFull,
  trigger: "blur",
};
ValidService.checkPhone = {
  pattern: /^(0|\+?84|0084)\d{9}$/,
  message: LanguageService.lang.valid_phone,
  trigger: "blur",
};
ValidService.checkSDTCoDinh_DiDong = {
  pattern: /^(0|02|\+?84|0084)\d{9,10}$/,
  message: LanguageService.lang.valid_phone,
  trigger: "blur",
};
ValidService.checkPhoneNew = {
  pattern: /^84\d{9}$|^(?!(0|84))\d{7,}$/,
  message: LanguageService.lang.valid_phone,
  trigger: "blur",
};
ValidService.checkMST = {
  pattern: /^[0-9]\d{9}$/,
  message: LanguageService.lang.valid_mst,
  trigger: "blur",
};
ValidService.checkDKKD = {
  pattern: /^[0-9]\d{5}$/,
  message: LanguageService.lang.valid_dkkd,
  trigger: "blur",
};
ValidService.checkNumber = {
  pattern: /^\d+$/,
  message: LanguageService.lang.valid_number,
  trigger: ["blur", "change"],
};
ValidService.checkNumberFloatNotNegative = {
  pattern: /^[\d.]+$/,
  message: LanguageService.lang.valid_floatNegative,
  trigger: "blur",
};
ValidService.checkNumberInteger = {
  pattern: /^[-]?[\d]+$/,
  message: LanguageService.lang.valid_integer,
  trigger: "blur",
};
ValidService.checkNumberFloat = {
  pattern: /^[-]?[\d.]+$/,
  message: LanguageService.lang.valid_float,
  trigger: "blur",
};
ValidService.checkEmail = {
  pattern: /^[a-z][a-z0-9_\.]{1,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/, // check email không có ký tự viết hoa
  // pattern:
  //   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z0-9]+\.)+[a-z]{2,}))$/,
  message: LanguageService.lang.valid_email,
  trigger: "blur",
};
ValidService.checkEmailNew = {
  pattern: /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,})+)$/,
  message: LanguageService.lang.valid_email,
  trigger: ["blur", "change"],
};
ValidService.checkSign = {
  pattern:
    /^[^ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳýỵỷỹ]*$/g,
  message: LanguageService.lang.valid_sign,
  trigger: "blur",
};
ValidService.checkSpaceString = {
  pattern: /\S/g,
  message: LanguageService.lang.valid_space,
  trigger: "blur",
};
ValidService.checkScript = {
  pattern: /^[\u00BF-\u1FFF\u2C00-\uD7FF\w\_\s]*$/g,
  message: LanguageService.lang.valid_script,
  trigger: "blur",
};
ValidService.checkLink = {
  pattern:
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
  message: LanguageService.lang.valid_link,
  trigger: "blur",
};
ValidService.checkTextFirst = {
  pattern: /^[a-zA-Z].*/g,
  message: LanguageService.lang.valid_textFirst,
  trigger: "blur",
};
ValidService.checkDateTime = {
  pattern:
    /^([1-9]|([012][0-9])|(3[01]))[/]([0]{0,1}[1-9]|1[012])[/]\d\d\d\d [012]{0,1}[0-9]:[0-6][0-9]$/g,
  message: LanguageService.lang.valid_dateTime,
  trigger: "blur",
};
ValidService.checkDate = {
  pattern:
    /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/g,
  message: LanguageService.lang.valid_date,
  trigger: "blur",
};
ValidService.checkYear = {
  pattern: /^\d{4}$/g,
  message: LanguageService.lang.valid_year,
  trigger: "blur",
};
ValidService.checkMonth = {
  pattern: /^\d{2}[/]\d{4}$/g,
  message: LanguageService.lang.valid_month,
  trigger: "blur",
};
ValidService.checkCampaign = {
  pattern: /^[a-z0-9-/]+$/g,
  message: LanguageService.lang.valid_campaign,
  trigger: "blur",
};
ValidService.checkURL = {
  pattern: /^https?:\/\//,
  message: LanguageService.lang.valid_url,
  trigger: "blur",
};
ValidService.checkCode = {
  pattern: /^[A-Z0-9_]+$/g,
  message: LanguageService.lang.valid_code,
  trigger: "blur",
};

ValidService.checkLength = (start, end) => {
  var mess = "";
  var pattern = "";

  if (start && end) {
    mess = `${LanguageService.lang.valid_insert} ${start} ${LanguageService.lang.valid_to} ${end} ${LanguageService.lang.valid_character}`;
    pattern = `.{${start},${end}}$`;
  } else if (start) {
    mess = `${LanguageService.lang.valid_insertThan} ${start} ${LanguageService.lang.valid_character}`;
    pattern = `.{${start},}$`;
  } else if (end) {
    mess = `${LanguageService.lang.valid_insertLess} ${end} ${LanguageService.lang.valid_character}`;
    pattern = `.{,${end}}$`;
  }
  return {
    pattern: new RegExp(pattern),
    message: mess,
    trigger: "blur",
  };
};

ValidService.pattern = (
  pattern,
  message = "Giá trị không hợp lệ!",
  trigger = "blur"
) => {
  return {
    pattern: typeof pattern === "string" ? new RegExp(pattern) : pattern,
    message: message,
    trigger: trigger,
  };
};

ValidService.checkNumberFloatNotNegative = {
  pattern: /^[\d.]+$/,
  message: `Không được nhập số âm`,
  trigger: "blur",
};
ValidService.checkMaxLength = (max) => {
  return {
    max: max,
    message: `Nhập tối đa ${max} ký tự`,
    trigger: "blur",
  };
};
ValidService.checkMinLength = (min) => {
  return {
    min: min,
    message: `Nhập tối thiểu ${min} ký tự`,
    trigger: ["blur", "change"],
  };
};
export default ValidService;
